import { call, put } from "redux-saga/effects";
import { enrollmentService } from "../services/enrollmentService";
import { enrollmentConstants } from "../actions/constants/enrollmentConstants";
import { commonConstants } from "../actions/constants/commonConstants";
import { downloadBlobFile } from "../services/helper";



function* getEnrollmentParams(action: any): any {
  try {
    const response = yield call(enrollmentService.getEnrollmentParams, action.payload);
    if (response.success) {
      yield put({ type: enrollmentConstants.getEnrollmentParamsSuccess, payload: response.resultObject });
    } else {
      yield put({ type: enrollmentConstants.getEnrollmentParamsFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: enrollmentConstants.getEnrollmentParamsFailure, payload: error });
  }
}

function* createEnrollment(action: any): any {
  try {
    const response = yield call(enrollmentService.createEnrollment, action.payload);
    if (response.success) {
      yield put({ type: enrollmentConstants.createEnrollmentSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: enrollmentConstants.createEnrollmentFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: enrollmentConstants.createEnrollmentFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* deleteEnrollment(action: any): any {
  try {
    const response = yield call(enrollmentService.deleteEnrollment, action.payload);
    if (response.success) {
      yield put({ type: enrollmentConstants.deleteEnrollmentSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: enrollmentConstants.deleteEnrollmentFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: enrollmentConstants.deleteEnrollmentFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* getEnrollmentView(action: any): any {
  try {
    const response = yield call(enrollmentService.getEnrollmentView, action.payload);
    if (response.success) {
      yield put({ type: enrollmentConstants.enrollmentViewSuccess, payload: response.resultObject });
    } else {
      yield put({ type: enrollmentConstants.enrollmentViewFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: enrollmentConstants.enrollmentViewFailure, payload: error });
  }
}

function* toggleEnrollment(action: any): any {
  try {
    const response = yield call(enrollmentService.toggleEnrollment, action.payload);
    if (response.success) {
      yield put({ type: enrollmentConstants.enrollmentToggleSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: enrollmentConstants.enrollmentToggleFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error) {
    yield put({ type: enrollmentConstants.enrollmentToggleFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error });
  }
}

function* exportEnrollment(action: any): any {
  try {
    const response = yield call(enrollmentService.exportEnrollment, action.payload);

    downloadBlobFile(response, 'enrollments', action.payload.format);
    
    yield put({ type: enrollmentConstants.exportEnrollmentSuccess });
    yield put({ type: commonConstants.showMessageSuccess, payload: 'Export completed successfully' });
  } catch (error: any) {
    yield put({ type: enrollmentConstants.exportEnrollmentFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.message || 'Export failed' });
  }
}

function* assignApplication(action: any): any {
  try {
    const response = yield call(enrollmentService.assignApplication, action.payload);
    if (response.success) {
      yield put({ type: enrollmentConstants.assignApplicationSuccess, payload: response.resultObject });
      yield put({ type: commonConstants.showMessageSuccess, payload: response.message });
    } else {
      yield put({ type: enrollmentConstants.assignApplicationFailure, payload: response.errorMessage });
      yield put({ type: commonConstants.showMessageFailure, payload: response.errorMessage });
    }
  } catch (error: any) {
    yield put({ type: enrollmentConstants.assignApplicationFailure, payload: error });
    yield put({ type: commonConstants.showMessageFailure, payload: error?.message || 'Assignment failed' });
  }
}

export const enrollmentSaga = {
  
  getEnrollmentParams,
  createEnrollment,
  deleteEnrollment,
  getEnrollmentView,
  toggleEnrollment,
  exportEnrollment,
  assignApplication
};
